import { CommonAdapter as CoreCommonAdapter } from '@core/adapters';
import { CommonApiEndpoint } from '@api-endpoint';
import { Product, tsProductClass } from '@core/dto';

export class CommonAdapter extends CoreCommonAdapter {
  async fetchProduct(): Promise<Product[] | []> {
    const response = await this.http.get<Product[] | []>(
      CommonApiEndpoint.fetchProduct
    );
    return response.data;
  }

  async fetchProductClass(): Promise<tsProductClass[] | []> {
    const response = await this.http.get<tsProductClass[] | []>(
      CommonApiEndpoint.fetchProductClass
    );
    return response.data;
  }
}
